import { useTranslation } from 'react-i18next';

const STATION_COUNT = 2;

export default function TrainAccess() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('access.train.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('access.train.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('access.train.titleEn')}
          </p>
          <div className="gold-line mx-auto"></div>
          <p className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[600px] mx-auto mt-5">
            {t('access.train.lead')}
          </p>
        </div>

        <div className="space-y-5">
          {Array.from({ length: STATION_COUNT }, (_, idx) => (
            <div
              key={idx}
              className="border border-background-200/60 bg-background-50 p-6"
            >
              <div className="flex flex-col sm:flex-row sm:items-start gap-4 sm:gap-6 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
                  <i className="ri-train-line text-accent-600 text-lg"></i>
                </div>
                <div className="flex-1">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2">
                    <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em]">
                      {t(`access.train.${idx}.name`)}
                    </h3>
                    <div className="flex items-center gap-3">
                      <span className="text-[13px] text-foreground-400 tracking-[0.05em] bg-background-200/60 px-2.5 py-1 whitespace-nowrap">
                        {t(`access.train.${idx}.line`)}
                      </span>
                      <span className="text-[14px] text-accent-600 tracking-[0.05em] font-medium whitespace-nowrap">
                        {t(`access.train.${idx}.time`)}
                      </span>
                    </div>
                  </div>
                  <p className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                    {t(`access.train.${idx}.directions`)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-[13px] text-foreground-400 tracking-[0.04em] leading-relaxed mt-5 text-center">
          {t('access.train.note')}
        </p>
      </div>
    </section>
  );
}
